import { useState, useRef, useEffect } from 'react';
import closeIcon from '../../images/icons/Icon2.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MAX_PORTAL_LOGO_SIZE = 250 * 1024; // 250KB size limit

const PortalLogo = ({ logoHostPath, APIEndpoint,logoOpen, userType, setLogoOpen }) => {

    const [logoPreview, setLogoPreview] = useState(null); // Replace with actual logo path or prop
    const [portalLogo, setPortalLogo] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const modalOpen = logoOpen && (userType === 'admin' || userType === 'superAdmin');
    const logoImg = `${logoHostPath}/assets/images/public/company-logo.png`;

    const [isError, setIsError] = useState(false);
    const [updateStatusText, setUpdateStatusText] = useState('');
     const { t } = useTranslation();
    useEffect(() => {
        checkLogoUrl();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnClickLogo = (e) => {
        e.stopPropagation();
        if (modalOpen) {
            setLogoOpen(false);
        }
        navigate('/');
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type !== 'image/png') {
                setIsError(true);
                setUpdateStatusText('Invalid file type. Please upload a PNG image.');
                return;
            }
            
            if (file.size > MAX_PORTAL_LOGO_SIZE) {
                setIsError(true);
                setUpdateStatusText(`File size exceeds the limit of ${MAX_PORTAL_LOGO_SIZE / 1024}KB. Please upload a smaller image.`);
                return;
            }

            setIsError(false);
            setUpdateStatusText('');

            setSelectedFile(file);
            setLogoPreview(URL.createObjectURL(file));
        }
        else {
            setSelectedFile(null);
            setLogoPreview(null); // Reset to original logo

        }
    };

    const handleModalClose = () => {
         setLogoOpen(false);
        setSelectedFile(null);
        setLogoPreview(null); // Reset to original logo
        
        setIsError(false);
        setUpdateStatusText('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            setIsError(true);
            setUpdateStatusText('No file selected. Please choose a PNG image to upload.');
            return;
        }

        const overwriteConfirmed = document.getElementById('overwriteConfirm').checked;
        if (!overwriteConfirmed) {
            setIsError(true);
            setUpdateStatusText('Please confirm that you want to overwrite the existing logo.');
            return;
        }
        setIsError(false);
        setUpdateStatusText('');

        const formData = new FormData();
        formData.append('file', selectedFile);
        
        try {
            await APIEndpoint.put('portal/logo', formData);

            setUpdateStatusText("Logo replaced successfully.");
            setPortalLogo(logoPreview);
            checkLogoUrl();
            setSelectedFile(null);
            setTimeout(() => {
                handleModalClose();
            }, 3000);

        } catch (response) {
            const errorObj = JSON.parse(response.message);
            const errorMessage = errorObj?.data?.error || 'An error occurred while uploading the logo.';
            
            setIsError(true);
            setUpdateStatusText(errorMessage);
        }
    };

    const checkLogoUrl = async () => {
        try {
            const imgUrl = await APIEndpoint.get(logoImg);
            if (imgUrl && !portalLogo?.length) {
                setPortalLogo(logoImg)
            }
        } catch (error) {
            // Handle error
        }
    }

    return (<>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="company-logo-container" onClick={(e) => { handleOnClickLogo(e) }}>
                {portalLogo ? (
                    <img src={portalLogo} alt="Company Logo" className="company-logo" />
                ) : (
                    <></>
                )}
            </div>
            {logoPreview && logoPreview !== portalLogo ? (
                <div className="company-logo-container">
                    <img src={logoPreview} alt="New Logo" className="company-logo" />
                </div>
            ) : (
                <></>
            )}
        </div>

        {modalOpen && (
        <>
            <div className="overlay" role="dialog" aria-modal="true" style={{ position: 'absolute', right: 'auto', width: '100%', justifyItems: 'center' }}>
                <div className={'dialog flexRow flexCol alignItemsCenter justifyContentCenter ' + (modalOpen ? 'dialog--open' : '')}>

                    <div className="dialog__content p-1">

                        <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
                            <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width100">{t(`pages.uploadLogo.title`)}</h2>
                            <button className='close-btn-ht' onClick={() => handleModalClose()}>
                                <img src={closeIcon} alt="close" data-icon='close'/>
                            </button>
                        </div>

                        <hr />
                    
                        <div  id="replaceImageBody" className="dialog__body_container flexWrap width100 justifyContentCenter p-4 overflow-auto sm-scrollbar">
                            <div className="flexRow company-logo-container justifyContentCenter m-2" style={{ marginBottom: 16 }}>
                                <label htmlFor="newLogo" className="newLogo"></label>
                                <img src={portalLogo} alt="Company Logo" className="company-logo" />
                            </div>
                            {logoPreview && logoPreview !== portalLogo && (
                                 <div className="flexRow company-logo-container justifyContentCenter m-2" style={{ marginBottom: 16 }}>
                                    <label htmlFor="newLogo" className="newLogo"></label>
                                    <img src={logoPreview} alt="New Logo" className="company-logo" />
                                </div>
                            )}

                            <div className={`dialog__container_item input-container margTop8 sm-scrollbar`}>
                                <div className={`dialog__description`}>

                                    <form onSubmit={handleSubmit}>
                                        <div className='flexCol alignItemsStart justifyContentStart margBottom4 border p-2 rounded mt-2'>
                                            <label className="fontRegular req py-3">{t(`pages.uploadLogo.title`)}:</label>
                                            <input
                                                type="file"
                                                accept="image/png"
                                                size={1}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                            />
                                            <em className="red fontSmall mt-4">{t(`pages.uploadLogo.uploadNote`)} {MAX_PORTAL_LOGO_SIZE / 1024}KB.</em>
                                        </div>

                                        <div className='flexRow py-3'>
                                            <label htmlFor="overwriteConfirm" className="overwriteConfirmCheckbox">
                                                <input type="checkbox" id="overwriteConfirm" required />
                                                <span className="checkmark"></span>&nbsp; {t(`pages.uploadLogo.testimonial`)}
                                            </label>
                                        </div>

                                        {updateStatusText ? <>
                                            <div className={ "dialog__statusBlock " + (isError ? 'alert_error' : 'alert_success') }>
                                                {updateStatusText}
                                            </div>
                                        </> : null}

                                        <div className="dialog__footer flexRow justifyContentSpaceEvenly margTop4">
                                            <button className="done-button m-2">{t(`pages.uploadLogo.submit`)}</button>
                                            <button className="cancel-button m-2" type="button" onClick={handleModalClose}>{t(`pages.uploadLogo.cancel`)}</button>                                
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        )}
    </>);
};

export default PortalLogo;